import '../assets/NcUserStatusIcon-62u43_6P.css';
import o from "vue";
import l from "@nextcloud/axios";
import { generateOcsUrl as c } from "@nextcloud/router";
import { getCapabilities as u } from "@nextcloud/capabilities";
import { r, J as d, a as e, K as h } from "./_l10n-FmsZpnE4.mjs";
import { n as v } from "./_plugin-vue2_normalizer-u6G_3nkj.mjs";
const f = `<!-- This icon is part of Material UI Icons. Copyright 2020 Google Inc., Apache-2.0 License -->
<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path fill="var(--color-success)" d="M4.8 11.2h6.4V4.8H4.8v6.4zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z" />
</svg>
`, n = `<!-- This icon is part of Material UI Icons. Copyright 2020 Google Inc., Apache-2.0 License -->
<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path fill="none" d="M-4-4h24v24H-4z" />
	<path fill="var(--color-warning)" d="M6.9.1C3 .6-.1 4-.1 8c0 4.4 3.6 8 8 8 4 0 7.4-3 8-6.9-1.2 1.3-2.9 2.1-4.7 2.1-3.5 0-6.4-2.9-6.4-6.4 0-1.9.8-3.6 2.1-4.7z" />
</svg>
`, p = `<!-- This icon is part of Material UI Icons. Copyright 2020 Google Inc., Apache-2.0 License -->
<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path fill="none" d="M-4-4h24v24H-4V-4z" />
	<path fill="var(--color-error)" d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z" />
	<path fill="#fdffff" d="M5 6.5h6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H5c-.8 0-1.5-.7-1.5-1.5S4.2 6.5 5 6.5z" />
</svg>
`, i = `<!-- This icon is part of Material UI Icons. Copyright 2020 Google Inc., Apache-2.0 License -->
<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path fill="none" d="M-4-4h24v24H-4V-4z" />
	<path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 3.2c2.7 0 4.8 2.1 4.8 4.8s-2.1 4.8-4.8 4.8S3.2 10.7 3.2 8 5.3 3.2 8 3.2z" />
</svg>
`;
r(d);
/**
 * @copyright 2023 Christopher Ng <chrng8@gmail.com>
 *
 * @author Christopher Ng <chrng8@gmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const g = (t) => {
  switch (t) {
    case "away":
      return e("away");
    case "busy":
      return e("busy");
    case "dnd":
      return e("do not disturb");
    case "online":
      return e("online");
    case "invisible":
      return e("invisible");
    case "offline":
      return e("offline");
    default:
      return t;
  }
};
r(h);
const m = {
  name: "NcUserStatusIcon",
  props: {
    /**
     * Set the user id to fetch the status
     */
    user: {
      type: String,
      default: null
    },
    /**
     * Set the status
     *
     * @type {'online' | 'away' | 'busy' | 'dnd' | 'invisible' | 'offline'}
     */
    status: {
      type: String,
      default: null,
      validator: (t) => [
        "online",
        "away",
        "busy",
        "dnd",
        "invisible",
        "offline"
      ].includes(t)
    },
    /**
     * Set the `aria-hidden` attribute
     *
     * @type {'true' | 'false'}
     */
    ariaHidden: {
      type: String,
      default: null,
      validator: (t) => [
        "true",
        "false"
      ].includes(t)
    }
  },
  data() {
    return {
      fetchedUserStatus: null
    };
  },
  computed: {
    activeStatus() {
      return this.status ?? this.fetchedUserStatus;
    },
    activeSvg() {
      return {
        online: f,
        away: n,
        busy: n,
        dnd: p,
        invisible: i,
        offline: i
      }[this.activeStatus] ?? null;
    },
    ariaLabel() {
      return this.ariaHidden === "true" ? null : e("User status: {status}", { status: g(this.activeStatus) });
    }
  },
  watch: {
    user: {
      immediate: !0,
      async handler(t, s) {
        if (!t || !u()?.user_status?.enabled) {
          this.fetchedUserStatus = null;
          return;
        }
        try {
          const { data: a } = await l.get(c("/apps/user_status/api/v1/statuses/{user}", { user: t }));
          this.fetchedUserStatus = a.ocs?.data?.status;
        } catch {
          this.fetchedUserStatus = null;
        }
      }
    }
  },
  mounted() {
    !this.user && !this.status && o.util.warn("[NcUserStatusIcon] The `user` or `status` prop should be set.");
  }
};
var w = function() {
  var s = this, a = s._self._c;
  return s.activeStatus ? a("span", { staticClass: "user-status-icon", class: {
    "user-status-icon--invisible": ["invisible", "offline"].includes(s.status)
  }, attrs: { role: "img", "aria-hidden": s.ariaHidden, "aria-label": s.ariaLabel }, domProps: { innerHTML: s._s(s.activeSvg) } }) : s._e();
}, S = [], b = /* @__PURE__ */ v(
  m,
  w,
  S,
  !1,
  null,
  "b17810e4",
  null,
  null
);
const z = b.exports;
export {
  z as N,
  g
};
